import { render, staticRenderFns } from "./DocumentsVer2.vue?vue&type=template&id=0e54e93c&scoped=true&"
import script from "./DocumentsVer2.vue?vue&type=script&lang=js&"
export * from "./DocumentsVer2.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsVer2.vue?vue&type=style&index=0&id=0e54e93c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54e93c",
  null
  
)

export default component.exports